window.addEventListener(`DOMContentLoaded`, () => {
  function replaceTextInNode(node, searchText, replacementText) {
    if (node.nodeType === Node.TEXT_NODE) {
      if (node.textContent.includes(searchText)) {
        node.textContent = node.textContent.replace(searchText, replacementText);
      }
    } else {
      for (let i = 0; i < node.childNodes.length; i++) {
        replaceTextInNode(node.childNodes[i], searchText, replacementText);
      }
    }
  }

  let currentDate = new Date();
  let year = currentDate.getFullYear();
  let month = currentDate.getMonth() + 1; // getMonth возвращает месяцы начиная с 0, поэтому добавляем 1
  let day = currentDate.getDate();

  let nextYearPeriod = +year + 3
  let bndaYear = (year - 2025) % 3
  let bndbYear = (year - 2026) % 3
  let bndcYear = (year - 2027) % 3

  if (bndaYear === 0 && month > 11 && day > 1) {
    replaceTextInNode(document.body, '1 декабря 2025 ', '1 декабря ' + nextYearPeriod + ' ');
  }
  if (bndbYear === 0 && month > 11 && day > 1) {
    replaceTextInNode(document.body, '1 декабря 2026 ', '1 декабря ' + nextYearPeriod + ' ');
  }
  if (bndcYear === 0 && month > 11 && day > 1) {
    replaceTextInNode(document.body, '1 декабря 2027 ', '1 декабря ' + nextYearPeriod + ' ');
  }

})
